module.exports = __webpack_public_path__ + "img/102046.43c31c3e.png";